import { resolveExcelColorToCss } from "./colorUtils";

export function escapeHtml(value) {
  const s = value == null ? "" : String(value);
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function textToHtml(value) {
  return escapeHtml(value).replace(/\r\n|\r|\n/g, "<br/>");
}

export function richTextToHtml(richTextRuns, themeColors) {
  if (!Array.isArray(richTextRuns) || richTextRuns.length === 0) return "";
  return richTextRuns.map((run) => {
    const t = run?.text ?? "";
    const f = run?.font || {};
    const style = {};
    const fontColor = resolveExcelColorToCss(f.color, themeColors);
    if (fontColor) style.color = fontColor;
    if (f.bold) style.fontWeight = 700;
    if (f.italic) style.fontStyle = "italic";
    if (f.underline) style.textDecoration = "underline";
    if (typeof f.name === "string") style.fontFamily = f.name;
    // Excel font size is in POINTS; convert to px (1pt = 96/72 px)
    if (typeof f.size === "number") style.fontSize = `${Math.max(8, Math.round(f.size * 96 / 72))}px`;
    const styleAttr = Object.keys(style).length
      ? ` style="${Object.entries(style).map(([k, v]) => `${k}:${String(v)}`).join(";")}"`
      : "";
    return `<span${styleAttr}>${textToHtml(t)}</span>`;
  }).join("");
}
